import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";
export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const REGISTRATION_VALIDATION_SCHEMA = yup.object().shape({
  tenantType: yup
    .string()
    .nullable()
    .required("Molimo Vas da odaberete tip korisnika"),

  firstName: yup
    .string()
    .when("tenantType", (tenantType: any, schema: yup.StringSchema) => {
      return tenantType[0] === "P"
        ? schema.required("Molimo Vas da unesete ime")
        : schema.notRequired();
    }),
  lastName: yup
    .string()
    .when("tenantType", (tenantType: any, schema: yup.StringSchema) => {
      return tenantType[0] === "P"
        ? schema.required("Molimo Vas da unesete prezime")
        : schema.notRequired();
    }),
  companyName: yup
    .string()
    .when("tenantType", (tenantType: any, schema: yup.StringSchema) => {
      return tenantType[0] === "C"
        ? schema.required("Molimo Vas da unesete naziv tvrtke")
        : schema.notRequired();
    }),
  taxNumber: yup
    .string()
    .when("tenantType", (tenantType: any, schema: yup.StringSchema) => {
      return tenantType[0] === "C"
        ? schema
            .length(11, "OIB mora sadržati točno 11 znakova")
            .required("Molimo Vas da unesete OIB")
        : schema.notRequired();
    }),
  email: yup
    .string()
    .email("Molimo Vas da unesete ispravnu email adresu")
    .required("Molimo Vas da unesete email adresu"),
  password: yup.string().required("Molimo Vas da unesete lozinku"),
  confirmPassword: yup
    .string()
    .test(
      "match",
      "Lozinka i ponovljena lozinka moraju biti jednake",
      function (value) {
        return value === this.parent.password;
      }
    ),
});
